import { render, staticRenderFns } from "./branch-list.vue?vue&type=template&id=21399afc&scoped=true&lang=pug"
import script from "./branch-list.vue?vue&type=script&lang=js"
export * from "./branch-list.vue?vue&type=script&lang=js"
import style0 from "./branch-list.vue?vue&type=style&index=0&id=21399afc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21399afc",
  null
  
)

export default component.exports